import { funEmoji } from '@dicebear/collection'
import { createAvatar } from '@dicebear/core'
import { useMemo } from 'react'

interface PropsAvatar {
  name: string | undefined
}

export function Avata({ name }: PropsAvatar) {
  const avatar = useMemo(() => {
    return createAvatar(funEmoji, {
      size: 32,
      radius: 50,
      eyes: ['closed2'],
      backgroundColor: ['059ff2'],
      mouth: ['lilSmile'],
      // ... other options
    }).toDataUriSync()
  }, [])

  return <img src={avatar} alt={name ? name : 'avatar'} />
}
